export const GET_PERSONAL_DETAILS_REQUEST =
  'legacy.user.GET_PERSONAL_DETAILS_REQUEST'
export const GET_PERSONAL_DETAILS_SUCCESS =
  'legacy.user.GET_PERSONAL_DETAILS_SUCCESS'
export const GET_PERSONAL_DETAILS_FAILURE =
  'legacy.user.GET_PERSONAL_DETAILS_FAILURE'
